export const TEMPLATE_CONFIG = [
  {
    key: "whatsapp_web",
    title: "WhatsApp Web",
    subtitle: "Templates Informais",
    text: "Modelos livres para mensagens rápidas e conversas diretas, ideais para atendimentos e comunicações pontuais.",
    icon: "WhatsApp",
    features: [
      "Texto livre",
      "Sem aprovação prévia",
      "Uso em conversas ativas",
      "Variáveis dinâmicas"
    ],
    tag: "Via QR Code",
    route: "/modelos/canal/whatsapp-web",
  },
  {
    key: "whatsapp_api",
    title: "WhatsApp API",
    subtitle: "Templates Oficiais",
    text: "Modelos padronizados e pré-aprovados pela Meta, indicados para notificações, alertas e campanhas em escala.",
    icon: "WhatsApp Business",
    features: [
      "Aprovação obrigatória pela Meta",
      "Botões de ação (CTA)",
      "Respostas rápidas",
      "Variáveis dinâmicas"
    ],
    tag: "API Oficial",
    route: "/modelos/canal/whatsapp-api",
  },
  {
    key: "email",
    title: "Email",
    subtitle: "Templates Institucionais",
    text: "Modelos flexíveis para comunicações formais, notificações e mensagens informativas por e-mail.",
    icon: "Email",
    features: [
      "Conteúdo textual",
      "Comunicação institucional",
      "Envio em massa",
      "Variáveis dinâmicas"
    ],
    tag: "Institucional",
    route: "/modelos/canal/email",
  },
  {
    key: "sms",
    title: "SMS",
    subtitle: "Templates Curtos",
    text: "Modelos objetivos para mensagens rápidas, como alertas, códigos e lembretes importantes.",
    icon: "SMS",
    features: [
      "Mensagens curtas",
      "Entrega via operadoras",
      "Ideal para alertas",
      "Variáveis dinâmicas"
    ],
    tag: "Notificações",
    route: "/modelos/canal/sms",
  },
];
